module.exports = __webpack_public_path__ + "static/media/14.218d187e.jpeg";